import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const getPostalCodeByCity = async (cityName: string, token: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/villes/code-postal`, {
      params: { city: cityName },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data // Doit contenir { codePostal: "XXXXX" }
  } catch (error) {
    console.error('❌ [getPostalCodeByCity] Erreur lors de la récupération du code postal :', error)
    throw error
  }
}
